export const USERNAME_CHARS_MIN_COUNT = 3
export const USERNAME_CHARS_MAX_COUNT = 16

export enum ErrorTranslationsKeys {
  'MAX_COUNT_PROFILES' = 'profiles_max_count',
}
